module.exports = __webpack_public_path__ + "img/hair.5b682083.png";